import { defineMessages } from 'react-intl-next';

const _default_1: {
	defaultAgentName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultAgentDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	defaultAgentName: {
		id: 'ai-mate.agent-selector.default-agent-name',
		defaultMessage: 'Chat',
		description:
			'Display name for the default Rovo Chat agent shown in agent selection menus and agent lists.',
	},
	defaultAgentDescription: {
		id: 'ai-mate.agent-selector.default-agent-description',
		defaultMessage: 'Get answers, generate new ideas, and accelerate everyday work.',
		description:
			"Description text displayed under the default Rovo Chat agent in agent selection or browse screens. Summarizes the agent's capabilities.",
	},
});
export default _default_1;
